import pushModel from "../../mixin/store/api/pushModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import changeModel from "@/mixin/store/api/changeModel";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        pushOrder(context, data) {
            return pushModel(context, 'auto_orders', data)
        },
        fetchOrders(context, search) {
            return fetchModels(context, 'auto_orders?', search.page + '&order[id]=desc', 'updateOrders');
        },
        fetchOrder(context, orderId) {
            return fetchModel(context, 'auto_orders', orderId, 'updateOrder');
        },
        putOrder(context, data) {
            return changeModel(context, 'auto_orders/' + data.orderId, data, 'updateOrder')
        },
    },
    mutations: {
        updateOrders(state, data) {
            state.orders = data
        },
        updateOrder(state, data) {
            state.order = data
        },
    },
    state: {
        orders: {
            models: [],
            totalItems: 0,
        },
        order: {
            autoOrderItems: []
        },
    },
    getters: {
        getOrders(state) {
            return state.orders.models
        },
        getOrder(state) {
            return state.order
        },
    },
}
